import Handlebars, { log } from 'handlebars';
import EventHub from '~/eventHub';
import super_category_template from '~/templates/selectSuperCategory.handlebars';
import getReportSuperCategoryService from '~/services/reportCategoryService';
import getReportSubCategoryService from '~/services/reportSubCategoryService';
import getAlertService from '~/services/alertService';
import getUtilsService from '~/services/utilsService';
import GeneralView from '~/generalView';
import jQuery from 'jquery';
import Settings from '~/settings.js';
import toastr from 'toastr';

var SelectCategoryView = GeneralView.View.extend({
	tagName: "div",
	className: 'select-category',
	superCategories: null,
	qtys: [],
	vdata: '',
	lastKind: '',
	timeout: null,
	events: {
		'click .category': 'renderCategories',
		'click .filterbtn': 'changeselectkindofreports',
		'keyup #searchreportsinput' : 'searchreports',
		'click .cancelsearch' : "cancelsearch",
	},
	
	render: function () {
		this.attachEvents();
		var handlebarsTemplate = Handlebars.template(super_category_template);
		this.$el.html(handlebarsTemplate({models: this.superCategories}));
		return this;
	},
	
	cancelsearch: function(){
		location.reload();
	},
	
	searchreports: function(){
		$(".filterbtncontainer").hide();
		var permissions = getUtilsService.getprofilepermissions();
		$('.homeloader').show();
		$('.totalofreports').hide();
		$('.foundreports-table').empty();
		$('.category-container').hide();
		$('#selectkindofreports').hide();
		var val = $("#searchreportsinput").val();
		val = val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		var re = new RegExp(val, 'g');
		clearTimeout(this.timeout);
		this.timeout = setTimeout(function () {
			if (val.length >= 3) {
				Parse.Cloud.run("getallreports",{"search": val}).then((allfoundreports) => {
					$('#classofreps').text("Resultado de Búsqueda");
					$('.foundreports-table').show();
					if (allfoundreports.length > 0) {
						$('.foundreports-table').append('<tr><th class="infotableheader item" key="tableheadernew">Reporte</th> <th class="infotableheader item" key="tableheaderclosed">Descripci&oacute;n</th><th class="infotableheader item" key="tableheaderdiscard">Categor&iacute;a</th><th class="infotableheader item" key="tableheaderassigned">Subcategor&iacute;a</th><th class="infotableheader item" key="tableheaderassigned">Fecha</th><th class="infotableheader item" key="tablecomments">Comentarios</th></tr>');
					}
					var totalr = 0;
					for (var i = 0; i < allfoundreports.length; i++) {
						var supercat = "Sin definir";
						var subcat = "Sin definir";
						var permission = false;
						if (allfoundreports[i].report.attributes.subCategory != undefined) {
							if (jQuery.isEmptyObject(allfoundreports[i].report.attributes.subCategory.attributes) == false) {
								permission = permissions.categories.includes(allfoundreports[i].report.attributes.subCategory.attributes.superCat.id);
								supercat = allfoundreports[i].report.attributes.subCategory.attributes.superCat.attributes.name;
								subcat = allfoundreports[i].report.attributes.subCategory.attributes.name;
							}
						}
						if(permission){
							var user = 'Sin definir';
							if (allfoundreports[i].report.attributes.userName != undefined) {
								if (allfoundreports[i].report.attributes.userName != "") {
									user = allfoundreports[i].report.attributes.userName.replace(re, `<mark>$&</mark>`);
								}
							}
							var d =  new Date();
							var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
							d = allfoundreports[i].report.attributes.createdAt.toLocaleDateString('es-GB', options);
							//$('.foundreports-table').append('<tr><td class="searhtableinfo"><a href="#report/'+allfoundreports[i].report.id+'"><button type="button" class="btn btn-primary gotoreportbtn">Ver reporte</button></a></td><td class="searhtableinfo searchtabledata">'+desc+'</td><td class="searhtableinfo searchtabledata">'+supercat+'</td><td class="searhtableinfo searchtabledata">'+subcat+'</td><td class="searhtableinfo searchtabledata">'+d+'</td><td class="searhtableinfo searchtabledata tabcomment "><ul class="'+allfoundreports[i].report.id+'"></ul></td></tr>');
							$('.foundreports-table').append('<tr><td class="searhtableinfo"><a href="#report/'+allfoundreports[i].report.id+'"><button type="button" class="btn btn-primary gotoreportbtn">Ver reporte</button></a></td><td class="searhtableinfo searchtabledata"><ul class="desc'+allfoundreports[i].report.id+'"></ul></td><td class="searhtableinfo searchtabledata">'+supercat+'</td><td class="searhtableinfo searchtabledata">'+subcat+'</td><td class="searhtableinfo searchtabledata">'+d+'</td><td class="searhtableinfo searchtabledata tabcomment "><ul class="'+allfoundreports[i].report.id+'"></ul></td></tr>');
							totalr++;
							if (allfoundreports[i].comments.length > 0) {
								for (var l = 0; l < allfoundreports[i].comments.length; l++) {
									var comm = allfoundreports[i].comments[l].replace(re, `<mark>$&</mark>`);
									$("."+allfoundreports[i].report.id).append('<li style="text-align:left;">'+comm+'</li>');
								}
							}
							if (allfoundreports[i].report.attributes.customreportvalues) {
								for (let j = 0; j < allfoundreports[i].report.attributes.customreportvalues.customdata.length; j++) {
									var type = allfoundreports[i].report.attributes.customreportvalues.customdata[j].type;
									if ( type == "smalltext" || type == "text" ) {
										var info = allfoundreports[i].report.attributes.customreportvalues.customdata[j].val.replace(re, `<mark>$&</mark>`);
										$(".desc"+allfoundreports[i].report.id).append('<li style="text-align:left;">'+info+'</li>');
									}
								}
							}
							var desc = '';
							if(allfoundreports[i].report.attributes.description != undefined){
								desc = allfoundreports[i].report.attributes.description.replace(re, `<mark>$&</mark>`);
								$(".desc"+allfoundreports[i].report.id).append('<li style="text-align:left;">'+desc+'</li>');
							}
						}
					}
					$('.homeloader').hide();
					$('.totalofreports').show();
					$('.totalofreports').text("Se encontraron " +totalr +" reportes");
					$('.cancelsearch').show();
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['SearchReportsError'],'Error');
						break;
					}
				});
			}
			else{
				$('.totalofreports').hide();
				$('.homeloader').hide();
				$('.totalofreports').show();
				$('.category-container').show();
				$('#selectkindofreports').show();
				$('#classofreps').text("Categorías de reporte");
				$(".cancelsearch").show();
			}
		}, 1000);
	},
	
	attachEvents: function() {
		this.listenTo(EventHub, 'category:render', data => {
			if (data.optval == undefined) {
				data.optval = 'MyReports';
			}
			this.renderSupercategories(data);
		});
	},
	
	changeselectkindofreports: function(e){
		$('.category-container').hide();
		$('.homeloader').show();
		var optVal = $(e.currentTarget).attr('value');;
		this.lastKind = optVal;
		this.vdata.optval = optVal;
		this.renderSupercategories(this.vdata);
	},
	
	getOnlyMyCategories: function(data){
		var permissions = getUtilsService.getprofilepermissions();
		var supercategories = data.models;
		if (!permissions.accessallreports){
			supercategories = [];
			for(var i=0;i<data.models.length;++i){
				if(permissions.categories.includes(data.models[i].id)){
					supercategories.push(data.models[i]);
				}
			}
		}
		return supercategories;
	},
	
	renderSupercategories: function(data) {
		var that = this;
		var permissions = getUtilsService.getprofilepermissions();
		this.vdata = data;
		this.qtys = [];
		var user = Parse.User.current();
		var selectedopt = {assigned: false, archived: false, my: false};
		data.assigned = undefined;
		var query = {};
		var typeofreport = 'assigned';
		query.status = 'open';
		var supercategoriesjson = {
			all: true,
			cache: false,
			rules:{
				equals: [{
					key: 'active',
					val: true
				}]
			}
		};
		switch(data.optval) {
			case "MyReports":
				data.assigned = true;
				query.assign = true;
				query.my = true;
				selectedopt = {assigned: false, archived: false , my: true};
			break;
			case "Asign":
				data.assigned = true;
				query.assign = true;
				query.my = false;
				selectedopt = {assigned: true, archived: false, my: true};
			break;
			case "Archive":
				data.assigned = null;
				typeofreport = null;
				query.status = null;
				query.my = true;
				if (permissions.accessallreports) {
					query.my = null;
				}
				supercategoriesjson.rules = {sort:{key: 'active', val: 'dsc'}};
				selectedopt ={assigned: false, archived: true, my: false};
			break;
			case "Discard":
				data.assigned = null;
				typeofreport = null;
				query.status = 'discard';
				query.my = true;
				if (permissions.accessallreports) {
					query.my = null;
				}
				supercategoriesjson.rules = {sort:{key: 'active', val: 'dsc'}};
				selectedopt ={assigned: false, archived: true, my: false, status: 'discard'};
			break;
			case "Close":
				data.assigned = null;
				typeofreport = null;
				query.status = 'close';
				query.my = true;
				if (permissions.accessallreports) {
					query.my = null;
				}
				supercategoriesjson.rules = {sort:{key: 'active', val: 'dsc'}};
				selectedopt ={assigned: false, archived: true, my: false, status: 'close'};
			break;
			default:
			break;
		}
		getAlertService().fetch({
			all: true,
			cache: false,
			rules:{
				equals: [{
					key: 'usersRelated',
					val: {__type: "Pointer", className: "_User", objectId: Parse.User.current().id }
				}]
			} 
		}).then(dataAlert => {
			getReportSuperCategoryService().fetch(supercategoriesjson).then(superCategories => {
				this.superCategories = superCategories.models;
				if ((!permissions.accessallreports || data.optval == 'Asign') && (data.optval != 'MyReports' && data.optval != 'Archive')) {
					//this.superCategories = that.getOnlyMyCategories(superCategories);
				}
				if (Settings.shogunmonitorapp && !permissions.accessallreports) {
					this.superCategories = that.getOnlyMyCategories(superCategories);
				}
				for (var i = 0; i < this.superCategories.length; i++) {
					this.superCategories[i].attributes.selectedopt = selectedopt;
					this.superCategories[i].attributes.accessallreps = permissions.accessallreports;
				}
				var handlebarsTemplate = Handlebars.template(super_category_template);
				this.$el.html(handlebarsTemplate({models: this.superCategories}));
				if (permissions.categories.length == 0) {
					$('#Asignfilterbtn').hide();
				}
				if (!permissions.accessallreports){
					$('.categorymaincontainer').hide();
				}
				else {
					$('.homeloader').hide();
				}
				for(var j = 0; j< this.superCategories.length; ++j){
					if(this.superCategories[j].attributes.iconFile == undefined){
						$('#icon'+this.superCategories[j].id).attr('src',"images/new/icons/7sO96C21Pf.svg");
					}

					var params = {
						equals: [{
							key: 'superCat',
							val: {
								__type: "Pointer",
								className: "superCategory",
								objectId: this.superCategories[j].id
							}
						},{
							key: 'active',
							val: true
						}]
					};
					if(data.optval == "Discard" ||data.optval == "Close"){
						params = {
							equals: [{
								key: 'superCat',
								val: {
									__type: "Pointer",
									className: "superCategory",
									objectId: this.superCategories[j].id
								}
							}]
						};
					}
					var categoryPromise = getReportSubCategoryService().fetch({
						all: true,
						cache: false,
						rules: params
					});
					Parse.Promise.when(categoryPromise).then(categoriesCollection => {
						var subcats = [];
						for (var i = 0; i < categoriesCollection.models.length; i++) {
							subcats.push(categoriesCollection.models[i].id);
						};
						Parse.Cloud.run('GetReportsbySubCategory', {subcategories: subcats, query: query, user: user.id}).then(function(reports) {
							var arrreports = [];
							for (var i = 0; i < reports.length; i++) {
								arrreports = arrreports.concat(reports[i]);
							}
							if(arrreports.length > 0){
								if(!that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id]){
									that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id] = 0;
								}
								that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id] += arrreports.length;
								$('#a'+arrreports[0].attributes.subCategory.attributes.superCat.id).fadeIn();
								$('#a'+arrreports[0].attributes.subCategory.attributes.superCat.id).attr("title",arrlang[lang]["gotosupcateg"]);
								$(".qty-reports").attr("title", arrlang[lang]["totalqtyreports"]);
								if (that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id] > 99){
									that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id] = '+99';
								}
								$('.'+arrreports[0].attributes.subCategory.attributes.superCat.id+'-qty').html(that.qtys[arrreports[0].attributes.subCategory.attributes.superCat.id]+"");
								$('.homeloader').hide();
							}
							else{
								if(data.optval != 'MyReports' ){
									if(permissions.accessallreports){
										$('.categorymaincontainer').show();
									}									
								}else{
									if(permissions.categories.indexOf(categoriesCollection.models[0].attributes.superCat.id)>-1){
										$('#a'+categoriesCollection.models[0].attributes.superCat.id).fadeIn();
									}
								}
								$('.'+categoriesCollection.models[0].attributes.superCat.id+'-qty').html("0");
								$('.homeloader').hide();
							}
							for(var l = 0 ; l < dataAlert.length; ++l){
								var badgeNormal = false;
								var badgeNoResponse = false;
								var isInArray = false;
								for(var m = 0; m < arrreports.length && !(badgeNormal || badgeNoResponse); ++m){
									if(dataAlert.models[l].attributes.report != null){
										if(arrreports[m].id == dataAlert.models[l].attributes.report.id){
											if(dataAlert.models[l].attributes.kind != 'noresponse'){
												badgeNormal = true;
											}
											else{
												badgeNoResponse = true;
											}
										}
									}
								}
								if (dataAlert.models[l].attributes.report != undefined && (badgeNormal || badgeNoResponse)){
									if(badgeNormal){
										var badge = $('#badge-'+dataAlert.models[l].attributes.report.attributes.subCategory.attributes.superCat.id);
										badge.show();
										badge.attr("title",arrlang[lang]["alertnewreports"]);
									}
									else{
										var badge = $('#badge_noresponse-'+dataAlert.models[l].attributes.report.attributes.subCategory.attributes.superCat.id);
										badge.show();
										badge.attr("title",arrlang[lang]["SuperCatBadgeNoResponse"]);
									}
								}
							}
						},
						(error) => {
							console.log(error);
							switch(error.code){
								case 100:
									toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
								break;
							}
						});
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				}
				this.translate();
				$('#'+data.optval+'filterbtn').css({"background-color" : "white" , "color" : "black", "cursor": "not-allowed","pointer-events": "none"});
				$("#classofreps").text(arrlang[lang][data.optval]);
				if(Settings.shogunmonitorapp){
					$('.notification-badge').css('margin-right','10%');
				}
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
});
export default SelectCategoryView;
